import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../../data";
import { useDispatch, useSelector } from "react-redux";
import { alertActions, userActions } from "../../redux/action";

const ProtectedPages = () => {
  const authUser = useSelector((el) => el.authentication.user);
  const user = useSelector((el) => el?.users?.profile);
  const loggedIn = useSelector((el) => el.authentication.loggedIn);
  const dispatch = useDispatch();
  let isAuth = false;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  try {
    const time =
      authUser && JSON.parse(atob(authUser?.jwt_token?.split(".")[1]))?.exp;
    const tokenIsExpired = time * 1000 < new Date();
    isAuth = !!authUser?.jwt_token && !tokenIsExpired;
    dispatch(userActions.updateUserTimezone({ id: user.id, timezone }));
  } catch { }

  if (!isAuth && loggedIn) {
    dispatch(alertActions.error("You must login first"));
  }
  return isAuth ? <Outlet /> : <Navigate to={ROUTES.LOGIN} />;
  // console.log(user);
};

export default ProtectedPages;
